import {Employee, EmployeeService} from 'client';
import {getService} from 'utilities';
import {queryClient} from 'views/QueryClientWrapper';

/**
 * A person's full profile (teams, reporting line, peers, reports), under the
 * same key the profile page uses, so a profile loaded here opens instantly
 * there too.
 */
export const profileQuery = (ldap: string) => ({
  queryKey: ['profile', ldap],
  queryFn: () => getService(EmployeeService).getProfileApiV1PeopleUserIdGet(ldap),
  staleTime: 5 * 60 * 1000,
});

/**
 * Start loading someone's profile before the pane needs it: on hover, and on
 * the rows the arrow keys are about to reach. The search row only carries a
 * name and role; the rest of the pane waits on this request.
 */
export const prefetchProfile = (person?: Pick<Employee, 'ldap'> | null) => {
  if (person?.ldap) void queryClient.prefetchQuery(profileQuery(person.ldap));
};
